/* eslint-disable no-unused-vars */
import React from "react";
import { FormControlLabel, Checkbox } from "@mui/material";

export default function PCheck(props) {
  return (
    <FormControlLabel
      control={
        <Checkbox
          style={{ height: "24px" }}
          checked={props.checked}
          //onChange={handleChange}
          onChange={(e) => props.onChange(e.target.checked)}
          color="secondary"
          disabled={props.disabled ? props.disabled : false}
        />
      }
      onFocus={(e) => {
        if (props.onFocus) props.onFocus(e);
      }}
      label={props.label}
    />
  );
}
